const INSERT_INFOS = 'INSERT_INFOS';
const SEND_LOGIN_EMAIL = 'SEND_LOGIN_EMAIL';

export { INSERT_INFOS, SEND_LOGIN_EMAIL };
